import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomReactSelect from '@components/CustomReactSelect';
import ModalContainer from '@components/modals/ModalContainer';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchAccessoriesList } from '@services/commonService';
import { onUpdateProductTag } from '@services/supplierService';

const AddAccessoriesParameter = ({ tagList = [], parameterType, onClose, onSuccess }) => {
	const [categories, setCategories] = useState([]);
	const [selectedItem, setSelectedItem] = useState(tagList);
	const { id } = useParams();
	const dispatch = useDispatch();
	const isLoading = useSelector((store) => store.loaderStore);

	useEffect(() => {
		dispatch(openLoader());
		fetchAccessoriesList()
			.then((res) => {
				let tmpCategories = res.map((item) => ({ value: item.constant, label: item.name }));
				setCategories(tmpCategories);
			})
			.finally(() => dispatch(closeLoader()));
	}, []);

	const onSave = async () => {
		try {
			// if (categories.length === 0) return;
			dispatch(openLoader());
			const response = await onUpdateProductTag(id, {
				supplierType: parameterType,
				brandingCategoryList: selectedItem?.map((item) => item?.value)
			});
			if (response) {
				onSuccess();
				onClose();
			}
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	return (
		<ModalContainer>
			<div className="common-popup filter-quick-search-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Add accessories parameter</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12">
							<div className="select-component chip-component mb-3 show">
								<label htmlFor="collection">Select Category</label>
								<CustomReactSelect
									selectedValue={selectedItem}
									allItems={categories}
									onSetSelectedItem={(value) => setSelectedItem(value)}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button disabled={isLoading} className="button size32 ml-2" onClick={() => onSave()}>
							Add
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddAccessoriesParameter;
